import getSoldWarrantyById from './getSoldWarrantyByIdQuery';
import getWarrantyTypeGroupQuery from './getWarrantyTypeGroupQuery';
import getWarrantyTypeQuery from './getWarrantyTypeQuery';

export const WarrantyService = {
  getWarrantyTypeGroupQuery,
  getWarrantyTypeQuery,
  getSoldWarrantyById,
};
